import React from 'react';
import { observer } from 'mobx-react';
import ContractFormService from '../services/ContractFormService';
import ContractProductsModal from './ContractProductsModal';
import { toJS } from 'mobx';
import { BRAZIL } from '../../../core/consts';

class ContractProductsFormContainer extends React.Component {
  render() {
    return (
      <ContractProductsModal
        options={toJS(ContractFormService.productsService.products)}
        onChange={ContractFormService.productsService.form.setValue}
        values={ContractFormService.productsService.form.getValues()}
        onSubmit={ContractFormService.productsService.handleSubmit}
        errors={ContractFormService.productsService.form.errors}
        onDelete={ContractFormService.productsService.handleDelete}
        loading={ContractFormService.productsService.fetch.fetching}
        submitting={ContractFormService.submit.fetching}
        currencyType={
          !ContractFormService.form.getValue('country') || BRAZIL.includes(ContractFormService.form.getValue('country'))
            ? 'real'
            : 'dollar'
        }
        isModalOpen={ContractFormService.productsService.isModalOpen}
        isEditingContract={!!ContractFormService.contractId}
        isEditingProduct={!!ContractFormService.productsService.isEditing}
        onReset={ContractFormService.productsService.form.reset}
        onClose={ContractFormService.productsService.handleToggleModal}
        onAddRange={ContractFormService.productsService.handleAddRange}
        onDeleteRange={ContractFormService.productsService.handleDeleteRange}
        hideCoreProducts={!!ContractFormService.contractId}
        type={ContractFormService.productsService.type}
        isV2={ContractFormService.isV2}
      />
    );
  }
}

export default observer(ContractProductsFormContainer);
